import { createSelector } from "reselect";

export const getTeam = state => state.teams.selected.data;
export const error = state => state.teams.selected.error;

export const listAll = createSelector( state => state.teams.all, all => all.data );
export const errorAll = state => state.teams.all.error;
export const isLoadingAll = state => state.teams.all.loading;